import { createRequestConstantNames } from 'store/util/createConstants';
import cc from 'store/util/createReduxConstant';

export const [
  FETCH_SRS_BUILDINGS,
  FETCH_SRS_BUILDINGS_SUCCESS,
  FETCH_SRS_BUILDINGS_FAILURE,
] = createRequestConstantNames(cc('FETCH_SRS_BUILDINGS'));
